(() => {
  function initCarousel(root) {
    const carouselListUnique = root.querySelector(".myapp-carousel-list-unique-more");
    const prevButtonUnique = root.querySelector(".myapp-nav-prev-unique-more");
    const nextButtonUnique = root.querySelector(".myapp-nav-next-unique-more");
    const scrollbarUnique = root.querySelector(".myapp-custom-scrollbar-unique-more");
    const scrollbarDragUnique = root.querySelector(".myapp-custom-scrollbar-drag-unique-more");

    if (!carouselListUnique || !prevButtonUnique || !nextButtonUnique || !scrollbarUnique || !scrollbarDragUnique) return;

    function updateNavButtonsVisibilityUnique() {
      if (window.innerWidth <= 600) {
        prevButtonUnique.style.display = "none";
        nextButtonUnique.style.display = "none";
      } else {
        prevButtonUnique.style.display = "none";
        nextButtonUnique.style.display = "flex";
      }
    }

    function showPrevButtonUnique() {
      if (window.innerWidth > 600) {
        prevButtonUnique.style.display = "flex";
      }
    }

    function updateScrollbarUnique() {
      const scrollWidth = carouselListUnique.scrollWidth;
      const clientWidth = carouselListUnique.clientWidth;
      const scrollLeft = carouselListUnique.scrollLeft;
      const scrollbarWidth = scrollbarUnique.clientWidth;

      if (scrollWidth <= clientWidth || scrollbarWidth <= 0) {
        scrollbarDragUnique.style.width = "100%";
        scrollbarDragUnique.style.transform = "translateX(0px)";
        return;
      }

      const dragWidth = Math.max((clientWidth / scrollWidth) * scrollbarWidth, 30);
      const maxScroll = scrollWidth - clientWidth;
      const dragLeft = maxScroll > 0
        ? (scrollLeft / maxScroll) * (scrollbarWidth - dragWidth)
        : 0;

      scrollbarDragUnique.style.width = dragWidth + "px";
      scrollbarDragUnique.style.transform = "translateX(" + dragLeft + "px)";
    }

    function afterScrollUpdate() {
      requestAnimationFrame(updateScrollbarUnique);
    }

    updateNavButtonsVisibilityUnique();
    window.addEventListener("resize", () => {
      updateNavButtonsVisibilityUnique();
      updateScrollbarUnique();
    });

    prevButtonUnique.addEventListener("click", () => {
      carouselListUnique.scrollBy({ left: 300, behavior: "smooth" });
      showPrevButtonUnique();
      setTimeout(afterScrollUpdate, 300);
    });

    nextButtonUnique.addEventListener("click", () => {
      carouselListUnique.scrollBy({ left: -300, behavior: "smooth" });
      showPrevButtonUnique();
      setTimeout(afterScrollUpdate, 300);
    });

    carouselListUnique.addEventListener("scroll", () => {
      showPrevButtonUnique();
      updateScrollbarUnique();
    });

    let isDraggingUnique = false;
    let dragStartXUnique = 0;
    let scrollStartXUnique = 0;
    let movedUnique = false;

    carouselListUnique.addEventListener("mousedown", (e) => {
      isDraggingUnique = true;
      movedUnique = false;
      dragStartXUnique = e.pageX;
      scrollStartXUnique = carouselListUnique.scrollLeft;
      carouselListUnique.style.cursor = "grabbing";
      e.preventDefault();
    });

    document.addEventListener("mouseup", () => {
      if (!isDraggingUnique) return;
      isDraggingUnique = false;
      carouselListUnique.style.cursor = "grab";
    });

    document.addEventListener("mousemove", (e) => {
      if (!isDraggingUnique) return;
      const dx = e.pageX - dragStartXUnique;
      if (Math.abs(dx) > 5) movedUnique = true;
      carouselListUnique.scrollLeft = scrollStartXUnique - dx;
      showPrevButtonUnique();
      updateScrollbarUnique();
    });

    carouselListUnique.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", (e) => {
        if (movedUnique) e.preventDefault();
      });
    });

    let isScrollbarDraggingUnique = false;
    let startXUnique = 0;
    let startScrollLeftUnique = 0;

    scrollbarDragUnique.addEventListener("mousedown", (e) => {
      isScrollbarDraggingUnique = true;
      startXUnique = e.pageX;
      startScrollLeftUnique = carouselListUnique.scrollLeft;
      document.body.style.userSelect = "none";
      e.preventDefault();
    });

    document.addEventListener("mouseup", () => {
      if (!isScrollbarDraggingUnique) return;
      isScrollbarDraggingUnique = false;
      document.body.style.userSelect = "auto";
    });

    document.addEventListener("mousemove", (e) => {
      if (!isScrollbarDraggingUnique) return;

      const dx = e.pageX - startXUnique;
      const scrollWidth = carouselListUnique.scrollWidth - carouselListUnique.clientWidth;
      const scrollbarWidth = scrollbarUnique.clientWidth - scrollbarDragUnique.offsetWidth;

      if (scrollWidth <= 0 || scrollbarWidth <= 0) return;

      const scrollDelta = (dx / scrollbarWidth) * scrollWidth;
      carouselListUnique.scrollLeft = startScrollLeftUnique + scrollDelta;

      showPrevButtonUnique();
      updateScrollbarUnique();
    });

    scrollbarUnique.addEventListener("mousedown", (e) => {
      if (e.target === scrollbarDragUnique) return;

      const rect = scrollbarUnique.getBoundingClientRect();
      const clickX = e.clientX - rect.left;
      const dragCenter = scrollbarDragUnique.offsetLeft + scrollbarDragUnique.offsetWidth / 2;

      const scrollWidth = carouselListUnique.scrollWidth - carouselListUnique.clientWidth;
      const scrollbarWidth = scrollbarUnique.clientWidth - scrollbarDragUnique.offsetWidth;

      if (scrollWidth <= 0 || scrollbarWidth <= 0) return;

      const delta = ((clickX - dragCenter) / scrollbarWidth) * scrollWidth;

      carouselListUnique.scrollBy({ left: delta, behavior: "smooth" });
      showPrevButtonUnique();
      setTimeout(afterScrollUpdate, 300);
    });

    updateScrollbarUnique();
  }

  function initAll() {
    document.querySelectorAll(".myapp-collection-carousel-unique-more").forEach((root) => {
      initCarousel(root);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }
})();
